module.exports = __webpack_public_path__ + "static/img/building.e09f8e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/building.png
// module id = 831
// module chunks = 1